enum ACTIONS {
    CREATE_LAYOUT = '[LAYOUT] CREATE',
    FETCH_LAYOUTS = '[LAYOUT] FETCH',
    BACKGROUND_FETCH_LAYOUTS = '[LAYOUT] BACKGROUND FETCH',
    PATCH_LAYOUT = '[LAYOUT] PATCH',
    DELETE_LAYOUT = '[LAYOUT] DELETE'
}

export default ACTIONS;